import { render, staticRenderFns } from "./OrderTableDetails.vue?vue&type=template&id=e60cd072&scoped=true&"
import script from "./OrderTableDetails.vue?vue&type=script&lang=js&"
export * from "./OrderTableDetails.vue?vue&type=script&lang=js&"
import style0 from "./OrderTableDetails.vue?vue&type=style&index=0&id=e60cd072&scoped=true&lang=css&"
import style1 from "./OrderTableDetails.vue?vue&type=style&index=1&id=e60cd072&scoped=true&lang=css&"
import style2 from "./OrderTableDetails.vue?vue&type=style&index=2&lang=css&"
import style3 from "./OrderTableDetails.vue?vue&type=style&index=3&lang=css&"
import style4 from "./OrderTableDetails.vue?vue&type=style&index=4&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60cd072",
  null
  
)

export default component.exports